export class LogRequest {
  message: string;
  clientUrl: string;
}

export class FormErrorLogRequest extends LogRequest {
  formId: string;
  formOverrideId: string;
  formIdQueue: string;
}

export class GenericErrorLogRequest extends LogRequest {
  stack: string;
  cause: string;
  name: string;

  constructor(stack: string, cause: string, name: string, errorString: string) {
    super();
    this.clientUrl = window.location.href;
    this.stack = stack;
    this.cause = cause;
    this.name = name;
    this.message = errorString;
  }
}

export class SignalRDiagnosticLogRequest extends LogRequest {
  connectionId: string;
  database: string;
  disconnectedDurationMs: number;
  dispatchUri: string;
  downlink: number;
  effectiveNetworkType: string;
  error: string;
  event: string;
  hubState: string;
  lastHubMessageAt: string;
  networkType: string;
  reconnectAttempt: number;
  retryDelayMs: number;
  roundTripTimeMs: number;
  saveData: boolean;
  timestamp: string;
  userAgent: string;
  username: string;
  visibilityState: string;
}
